/**
 * Constantes para los tipos de prescriptores
 * Evita el uso de magic strings en toda la aplicación
 */
export const PRESCRIPTOR_TYPES = {
  comercial: 'comercial',
  privada: 'privada',
  universidades: 'universidades',
  rentingAuto: 'rentingAuto',
  digital: 'digital'
} as const;

/**
 * Tipo TypeScript derivado de las constantes para mayor type safety
 */
export type PrescriptorType = typeof PRESCRIPTOR_TYPES[keyof typeof PRESCRIPTOR_TYPES];

export function isPrescComGenerico(tipo: string | null): boolean {
  return tipo === PRESCRIPTOR_TYPES.comercial;
}

export function isPrescBancaPrivada(tipo: string | null): boolean {
  return tipo === PRESCRIPTOR_TYPES.privada;
}

export function isPrescRentingAuto(tipo: string | null): boolean {
  return tipo === PRESCRIPTOR_TYPES.rentingAuto;
}

export function isPrescUniversidades(tipo: string | null): boolean {
  return tipo === PRESCRIPTOR_TYPES.universidades;
}

export function isPrescDigital(tipo: string | null): boolean {
  return tipo === PRESCRIPTOR_TYPES.digital;
}